import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ShoppingBagIcon, PhoneIcon } from 'lucide-react';
import { BrandMark } from './BrandMark';
const links = [{
  to: '/',
  label: 'Accueil'
}, {
  to: '/carte',
  label: 'Notre carte'
}, {
  to: '/commander',
  label: 'Commander'
}, {
  to: '/traiteur',
  label: 'Traiteur'
}, {
  to: '/ou-nous-trouver',
  label: 'Où nous trouver'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 border-b-[3px] border-noir bg-creme" data-id="element-106" data-mp="31e1s82m52gz2">
      <div className="bg-noir text-creme" data-id="element-107" data-mp="36aiib2cwf5es">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] md:px-8" data-id="element-108" data-mp="3baelx0hooutt">
          <span className="text-jaune" data-id="element-109" data-mp="3fbzu48j9wkxo">Agence de voyage culinaire · Tourtes du monde faites maison</span>
          <a href="tel:+33600000000" className="hidden items-center gap-1.5 transition-colors duration-150 ease-out hover:text-jaune sm:flex" data-id="element-110" data-mp="2wm5sj0fun30k">
            <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-111" data-mp="2mng8p24e78ho" />
            06 00 00 00 00
          </a>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-4 py-3 md:px-8" data-id="element-112" data-mp="2hpy8q18cs3lt">
        <Link to="/" className="shrink-0" aria-label="Juste au coin d'la rue — accueil" data-id="element-113" data-mp="3fd6p5hthymgy">
          <BrandMark data-id="element-114" data-mp="3aec7ij79n3yf" />
        </Link>

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-115" data-mp="35l0x6838w51r">
          <ul className="flex items-center gap-1" data-id="element-116" data-mp="30mfwy8nztldb">
            {links.map(link => <li key={link.to} data-id="element-117" data-mp="30klm5n6fr9my">
                <NavLink to={link.to} className={({
              isActive
            }) => `block px-3 py-2 font-display text-sm uppercase tracking-wide transition-colors duration-150 ease-out ${isActive ? 'bg-noir text-jaune' : 'text-noir hover:bg-jaune'}`} data-id="element-118" data-mp="1wzcai6xfphp">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-119" data-mp="1mla47fc8py7h">
          <Link to="/commander" className="hidden items-center gap-2 border-[3px] border-noir bg-rouge px-4 py-2 font-display text-sm uppercase tracking-wide text-creme shadow-hard-sm transition-transform duration-150 ease-out hover:-translate-y-0.5 sm:inline-flex" data-id="element-120" data-mp="18nbp27q3hxqx">
            <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-121" data-mp="13ngyy6e59c6x" />
            Commander
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" className="inline-flex items-center justify-center border-[3px] border-noir bg-jaune p-2 lg:hidden" data-id="element-122" data-mp="2t2ezrqs4st8j">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-123" data-mp="hgmo0noevmc2" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-124" data-mp="w4zmbraz1h9q" />}
            <span className="sr-only" data-id="element-125" data-mp="rdrbcqtztnug">Menu</span>
          </button>
        </div>
      </div>

      {open && <nav id="mobile-nav" aria-label="Navigation mobile" className="border-t-[3px] border-noir bg-creme lg:hidden" data-id="element-126" data-mp="154w5jdeldnxe">
          <ul className="mx-auto max-w-7xl px-4 py-2 md:px-8" data-id="element-127" data-mp="105tbeo05h247">
            {links.map(link => <li key={link.to} className="border-b border-noir/10 last:border-0" data-id="element-128" data-mp="1f2k9mty387s8">
                <NavLink to={link.to} className={({
            isActive
          }) => `block py-3 font-display text-lg uppercase ${isActive ? 'text-rouge' : 'text-noir'}`} data-id="element-129" data-mp="1a4s95bjdndcf">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>}
    </header>;
}